export default "__VITE_ASSET__1k6t8FDd__"